// extracted by mini-css-extract-plugin
module.exports = {"header-title":"header-title","title":"title","icon":"icon"};